import React from "react";
import { useNavigate } from "react-router-dom";
import "./pagenotFound.css";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="errorContainer">
      <div className="errorFlexCenter">
        <div className="container">
          <div className="row">
            <div className={`col-sm-8 offset-sm-2 errorContent}`}>
              <h1 className="errorDigits">
                <span>4</span>
                <span>0</span>
                <span>4</span>
              </h1>
              <h5 className="errorTitle">Oops! Page not found</h5>
              <p className="errorMessage">
                We are sorry, but the page you requested was not found
              </p>
              <button className="errorButton" onClick={() => navigate("/")}>
                Go home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
